import React, { Component, Fragment } from 'react';
import { joinClasses } from 'components/utils/react_helper';
import I18n from '~/utils/translations';

export default class CompareMap extends Component {
  constructor(props) {
    super(props);

    this.mapDiv = null;
    this.map = null;
    this.state = {
      currentView: 'map',
    };
  }

  componentDidMount() {
    this.initialiseMap();
  }

  render() {
    return (
      <Fragment>
        {this.renderNav()}
        <div ref={(mapDiv) => (this.mapDiv = mapDiv)} className="home-map__container"></div>
      </Fragment>
    );
  }

  get propertyPosition() {
    return {
      lat: parseFloat(this.props.comparedListings[0].latitude),
      lng: parseFloat(this.props.comparedListings[0].longitude),
    };
  }

  renderNav = () => {
    const tabs = [
      {
        id: 'map',
        text: I18n.t('pages.homes.map.map_view_tab'),
        onClick: this.showMapView,
      },
    ];

    return (
      <ul className="home-map__nav">
        {tabs.map((tab) => (
          <li key={tab.id} className={this.navItemClasses(tab.id)}>
            <button className="home-map__nav-link" onClick={tab.onClick}>
              {tab.text}
            </button>
          </li>
        ))}
      </ul>
    );
  };

  navItemClasses = (tabId) => {
    return joinClasses(['home-map__nav-item', this.state.currentView == tabId && 'home-map__nav-item--active']);
  };

  initialiseMap = () => {
    this.map = new google.maps.Map(this.mapDiv, {
      center: this.propertyPosition,
      zoom: 10,
      zoomControl: true,
      mapTypeControl: false,
      rotateControl: true,
      fullscreenControl: true,
      styles: MAPSTYLES,
    });

    var infowindow = new google.maps.InfoWindow();

    this.props.comparedListings.forEach((listing, i) => {
      let marker = new google.maps.Marker({
        position: new google.maps.LatLng(parseFloat(listing.latitude), parseFloat(listing.longitude)),
        icon: `https://s3.eu-west-2.amazonaws.com/resident.ly-production-static-assets/home-pin-2021.svg`,
        map: this.map,
        animation: google.maps.Animation.DROP,
        title: 'My tooltip',
      });

      google.maps.event.addListener(
        marker,
        'click',
        (function (marker, i) {
          return function () {
            infowindow.setContent(` ${listing.displayAddress}`);
            infowindow.open(this.map, marker);
          };
        })(marker, i)
      );
    });
  };

  showMapView = () => {
    this.resetMapView();
    this.setState({ currentView: 'map' });
  };

  resetMapView = () => {
    this.map.setCenter(this.propertyPosition);
    this.map.setZoom(17);
  };
}

const MAPSTYLES = [
  {
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5',
      },
    ],
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#616161',
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#f5f5f5',
      },
    ],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#bdbdbd',
      },
    ],
  },
  {
    featureType: 'poi',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#eeeeee',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#757575',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e5e5e5',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#e1f4c3',
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#757575',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dadada',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#616161',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e',
      },
    ],
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e5e5e5',
      },
    ],
  },
  {
    featureType: 'transit.station',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'transit.station',
    elementType: 'geometry',
    stylers: [
      {
        color: '#eeeeee',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#c9c9c9',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#c3e0f4',
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e',
      },
    ],
  },
];
